module.exports = __webpack_public_path__ + "img/drunk_256.63df9e15.png";